import { createSlice } from '@reduxjs/toolkit';
import { fetchYears, fetchCategories, fetchBlocks, fetchPanchayats, fetchVillages } from '../../services/api';

const initialState = {
    years: [],
    categories: [],
    blocks: [],
    panchayats: [],
    villages: [],
    loading: false,
};

const housingSlice = createSlice({
    name: 'housingData',
    initialState,
    reducers: {
        setYears(state, action) { state.years = action.payload },
        setCategories(state, action) { state.categories = action.payload },
        setBlocks(state, action) { state.blocks = action.payload },
        setPanchayats(state, action) { state.panchayats = action.payload },
        setVillages(state, action) { state.villages = action.payload },
        setLoading(state, action) { state.loading = action.payload }
    }
});

export const { setYears, setCategories, setBlocks, setPanchayats, setVillages, setLoading } = housingSlice.actions;

export const loadInitialData = () => async (dispatch) => {
    dispatch(setLoading(true));
    try {
        const [years, categories, blocks, panchayats, villages] = await Promise.all([
            fetchYears(),
            fetchCategories(),
            fetchBlocks(),
            fetchPanchayats(),
            fetchVillages(),
        ]);
        dispatch(setYears(years.data));
        dispatch(setCategories(categories.data));
        dispatch(setBlocks(blocks.data));
        dispatch(setPanchayats(panchayats.data));
        dispatch(setVillages(villages.data));
    } catch (error) {
        console.error('Failed to load data', error);
    } finally {
        dispatch(setLoading(false));
    }
};

export default housingSlice.reducer;
